const React = require('react');

const discountMapper = (discount) => ({
  name: discount?.name,
  type: discount?.type,
  detail: discount?.detail,
  legal_terms: discount?.legal_terms,
  price: {
    cents: discount?.price?.cents,
    amount: discount?.price?.amount,
    text_value: discount?.price?.text_value,
    currency_id: discount?.price?.currency_id,
    currency_symbol: discount?.price?.currency_symbol,
    decimal_separator: discount?.price?.decimal_separator,
  },
});

const taxesMapper = (taxes) => {
  if (!Array.isArray(taxes)) {
    return taxes;
  }

  return taxes.map((tax) => ({
    detail: tax?.detail,
  }));
};

const installmentsMapper = (installments) => {
  if (!Array.isArray(installments)) {
    return installments;
  }

  return installments.map((installment) => ({
    title: installment?.title,
    amount: installment?.amount,
    detail: installment?.detail,
    is_pcj: installment?.is_pcj,
    options: installment?.options,
    quantity: installment?.quantity,
    recommended: installment?.recommended,
    contract_url: installment?.contract_url,
    is_modifiable: installment?.is_modifiable,
    discount_detail: installment?.discount_detail,
    details_required: installment?.details_required,
    is_interest_free: installment?.is_interest_free,
    total_finance_cost: installment?.total_finance_cost,
    interest_total_amount: installment?.interest_total_amount,
    installment_total_amount: installment?.installment_total_amount,
    total_items_amount_plus_interest: installment?.total_items_amount_plus_interest,
  }));
};

const paymentMethodMapper = (paymentMethod) => ({
  id: paymentMethod?.id,
  type: paymentMethod?.type,
  title: paymentMethod?.title,
  detail: paymentMethod?.detail,
  balance: paymentMethod?.balance,
  option_id: paymentMethod?.option_id,
  promotional: paymentMethod?.promotional,
  recommended: paymentMethod?.recommended,
  combinations: paymentMethod?.combinations,
  total_amount: paymentMethod?.total_amount,
  next_due_date: paymentMethod?.next_due_date,
  property_type: paymentMethod?.property_type,
  security_code: paymentMethod?.security_code,
  esc_available: paymentMethod?.esc_available,
  additional_info: paymentMethod?.additional_info,
  show_installments: paymentMethod?.show_installments,
  tokenization_with_cvv: paymentMethod?.tokenization_with_cvv,
  notification_single_installment: paymentMethod?.notification_single_installment,
  installments: installmentsMapper(paymentMethod?.installments),
  discount: discountMapper(paymentMethod?.discount),
  taxes: taxesMapper(paymentMethod?.taxes),
});

const usePaymentMethod = ({ paymentMethods = [] }) => {
  const [paymentMethod, setPaymentMethod] = React.useState(
    paymentMethodMapper(paymentMethods[0]),
  );

  return {
    paymentMethod,
    setPaymentMethod,
  };
};

const usePaymentMethodHook = { usePaymentMethod };
usePaymentMethodHook.taxesMapper = taxesMapper;
usePaymentMethodHook.discountMapper = discountMapper;
usePaymentMethodHook.installmentsMapper = installmentsMapper;
usePaymentMethodHook.paymentMethodMapper = paymentMethodMapper;

module.exports = usePaymentMethodHook;